import { Component } from '@angular/core';

@Component({
	selector: 'app-backoffice-mobile-layout',
	templateUrl: './backoffice-mobile-layout.component.html',
	styleUrls: ['./backoffice-mobile-layout.component.less'],
})
export class BackofficeMobileLayoutComponent {}
